export const FOLHA_PONTO_OLD = 'FOLHA_PONTO_OLD';
export const FOLHA_PONTO = 'FOLHA_PONTO';
export const PROGRAMACAO_DIARIA = 'PROGRAMACAO_DIARIA';
export const OLERITE = 'OLERITE';
export const FOLHA_PONTO_FULL_ACCESS = 'FOLHA_PONTO_FULL_ACCESS';
export const PROCEDIMENTO_NORMAS_FULL_ACCESS = 'PROCEDIMENTO_NORMAS_FULL_ACCESS';
export const PRODUTO_PEDIDO_DELETE_ACCESS = 'PRODUTO_PEDIDO_DELETE_ACCESS';
export const NSIR_STATUS_UPDATE = 'NSIR_STATUS_UPDATE';
export const AUDITORIA_NSIR = 'AUDITORIA_NSIR';